<template>

  <div ref="fullpage">
    <!-- 首页图片 -->
    <section class="fullpage-section">
      <img src="https://youke1.picui.cn/s1/2025/08/26/68adc2c3b1782.png" class="product-image" alt="首页"></img>
    </section>


    <!-- 冬虫夏草图片带局部放大效果 -->
    <section class="fullpage-section">
      <CordycepsZoom />
    </section>
    <section class="fullpage-section">
      <productsSwper :goodList="productsA"></productsSwper>
    </section>
    <section class="fullpage-section">
      <productsSwper :goodList="productsB"></productsSwper>
    </section>
    <section class="fullpage-section">
      <productsSwper :goodList="productsC"></productsSwper>
    </section>


    <!-- 产品轮播组件 -->




    <div class="page-dots">
      <span v-for="(dot, index) in 5" :key="index" class="dot" :class="{ active: activeIndex === index }"
        @click="scrollToSection(index)"></span>
    </div>
  </div>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import productsSwper from '@/components/products-swper.vue'
import CordycepsZoom from '@/components/CordycepsZoom.vue'

// 产品数据
const productsA = ref([
  { img: "https://youke1.picui.cn/s1/2025/08/27/68af28a5b314c.png" },
  { img: "https://youke1.picui.cn/s1/2025/08/27/68af28a5dd7f0.png" },
  { img: "https://youke1.picui.cn/s1/2025/08/27/68af28a4cb5b7.png" }
])

const productsB = ref([
  { type: "products" },
  { img: "https://youke1.picui.cn/s1/2025/08/27/68af29a7acbea.png" },
  { img: "https://youke1.picui.cn/s1/2025/08/27/68af29a7b0140.png" },
  { img: "https://youke1.picui.cn/s1/2025/08/27/68af29a69353e.png" }
])

const productsC = ref([
  { img: "https://youke1.picui.cn/s1/2025/08/27/68af28358e20a.png" },
  { img: "https://youke1.picui.cn/s1/2025/08/27/68af28364311b.png" }
])

// 放大功能相关状态
const showZoom = ref(false)
const activeZoom = ref('')
const zoomX = ref(0)
const zoomY = ref(0)

// 这里替换为您实际的局部放大图片URL
const zoomImages = ref({
  part1: "https://youke1.picui.cn/s1/2025/08/27/68af2522e7078.png", // 示例：左上局部
  part2: "https://youke1.picui.cn/s1/2025/08/27/68af2522a001d.png", // 示例：右上局部
  part3: "https://youke1.picui.cn/s1/2025/08/27/68af252341b59.png", // 示例：左下局部
  part4: "https://youke1.picui.cn/s1/2025/08/27/68af252342480.png"  // 示例：右下局部
})

// 处理鼠标移动，调整放大预览位置
const handleMouseMove = (e) => {
  // 调整偏移量，防止预览框超出视口
  const offset = 20
  zoomX.value = e.clientX + offset
  zoomY.value = e.clientY + offset
}
/** ---------------- 整屏滚动逻辑（保留原功能） ---------------- **/
const activeIndex = ref(0) // 当前激活的屏幕索引
const fullpage = ref(null) // 整屏容器DOM引用

// 点击导航点跳转对应屏幕
const scrollToSection = (index) => {
  const el = fullpage.value.children[index]
  el.scrollIntoView({ behavior: "smooth" })
  activeIndex.value = index
}

onMounted(() => {
  // 监听滚动，更新导航点激活状态
  fullpage.value.addEventListener("scroll", () => {
    const sections = fullpage.value.children
    let current = 0
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].getBoundingClientRect().top >= 0) {
        current = i
        break
      }
    }
    activeIndex.value = current
  })
})

</script>

<style scoped>
/* 首页基础样式（移除原地图相关样式，仅保留其他屏样式） */
/* .fullpage-wrapper {
  height: calc(100vh - 100px);
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  position: relative;
  background-color: #51423A;
  padding-top: 100px;
} */

.fullpage-section {
  height: 100vh;
  scroll-snap-align: start;

}





.product-image,
.main-image {
  width: 100%;
  display: block;
  margin: 0 auto;
}

/* 放大效果容器 */
.zoom-container {
  position: relative;
  margin: 20px 0;
}

/* 交互热区样式 */
.hotspot {
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  cursor: zoom-in;
  transition: all 0.3s ease;
}



/* 热区位置 - 可根据实际图片内容调整 */
.hotspot-1 {
  top: 180px;
  left: 560px;
}

.hotspot-2 {
  top: 200px;
  right: 440px;
}

.hotspot-3 {
  bottom: 160px;
  left: 500px;
}

.hotspot-4 {
  bottom: 130px;
  right: 600px;
}

/* 放大预览框样式 */
.zoom-preview {
  position: fixed;
  width: 400px;
  height: 400px;

  border-radius: 50%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  z-index: 100;
  overflow: hidden;
  background-color: #fff;
  pointer-events: none;
}

.zoom-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 原有样式保持不变 */
.pro-title1 {
  color: #FDD097;
  font-size: 70px;
  text-align: center;
  padding-top: 50px;
}

.pro-title2 {
  color: #FDD097;
  font-size: 62px;
  text-align: center;
  margin-top: 15px;
}

.pro-list-top {
  color: #FCD197;
  font-size: 50px;
  text-align: center;
}

.pro-img {
  width: 300px;
  object-fit: cover;
  height: 300px;
  text-align: center;
}

.pro-list {
  display: flex;
  margin: auto;
  max-width: 1300px;
  justify-content: space-between;
  margin-top: 40px;
}

.pro-title {
  color: #FCD197;
  font-size: 32px;
  text-align: center;
  margin-top: 20px;
}

.pro-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* 右侧导航点 */
.page-dots {
  position: fixed;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ccc;
  cursor: pointer;
  transition: background 0.3s, transform 0.3s;
}

.dot.active {
  background: #fff;
}
</style>
